import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { activateUserAction, deactivateUserAction } from '../../../redux/actions/usersActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';

const BlockUserModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.users?.user);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(user.isActive ? deactivateUserAction(user) : activateUserAction(user));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={user.isActive ? 'Блокування користувача' : 'Розблокування користувача'}
      loading={loading}
      onClose={onModalClose}
      body={
        user.isActive
          ? 'Ви дійсно бажаєте заблокувати цього користувача?'
          : 'Ви дійсно бажаєте розблокувати цього користувача?'
      }
      actionButton={
        <Button
          onClick={onSubmit}
          disabled={loading}
          variant={'primary'}
          children={user.isActive ? 'Блокувати' : 'Розблокувати'}
        />
      }
    />
  );
};

export default BlockUserModal;
